import Icon from '../components/Icon.vue'

Icon.register({"eject":{"width":1538,"height":1792,"paths":[{"d":"M14 979l710-710q19-19 45-19t45 19l710 710q19 19 13 32t-32 13h-1472q-26 0-32-13t13-32zM1473 1536h-1408q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1408q26 0 45 19t19 45v256q0 26-19 45t-45 19z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eject.js
// module id = 0Plp
// module chunks = 1